<template>
  <div v-if="item">
    <FileUpload :allowMultiple="false" :allowRemove="false" :allowedType="'image/jpeg,image/png,image/gif,image/jfif'"
                :currentImageLink="!empty(value) ? uploadRoot + value : false"
                :icon="'fad fa-edit'"
                :previewClass="'d-flex border-dashed w-125px cursor-pointer h-125px align-items-center justify-content-center m-auto rounded'"
                :text="'Photo'" :type="'full'" accept=".jpg,.jpeg,.png,.gif,.jfif" v-model="value"></FileUpload>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import FileUpload from "@/components/FileUpload.vue";
import {api} from "@/services/Api";

@Component({
  components: {FileUpload}
})
export default class PropertyPhoto extends Vue {
  uploadRoot = api.uploadRoot

  @Prop() itemUuid!: string
  @Prop() propertyCode!: string

  get item() {
    return this.$store.getters["contractStore/getEntity"]('items', this.itemUuid)
  }

  get value() {
    return this.item?.properties?.[this.propertyCode]
  }

  set value(v: any) {
    if (this.item) {
      Vue.set(this.item.properties, this.propertyCode, v)
    }
  }
}
</script>

<style scoped>
</style>
